import { useQuery } from '@tanstack/react-query';

import { PropertyFilters, getAvailableProperties } from '../api';

export const useGetAvailableProperties = (filters?: PropertyFilters) => {
  return useQuery({
    queryKey: ['getAvailableProperties', filters],
    queryFn: () => getAvailableProperties(filters),
    staleTime: 0,
    keepPreviousData: true,
    select: (data) => ({
      properties: data.data.resource,
      total: data.data.total ?? data.data.resource.length,
    }),
  });
};
